// Backend property names for the content translations of subtype fields.
//
// The backend addresses them with a *formatted* property string: it declares the key as
// `subtype[0].name` / `subtype[0].checklistItem[1].text` and `TranslationKey.FormattedProperty`
// substitutes the nested ids for `[0]`, `[1]` (see StringTranslationExtensions.Translate).
// The Translations rows therefore hold `subtype42.name` / `subtype42.checklistItem7.text`, and
// the GET endpoint takes exactly that string — so the client formats the key itself instead of
// using the PATCH-only `nestedId` query param, and GET/PATCH stay symmetric.
//
// Both builders need persisted ids: subtypes and checklist items are only translatable after
// the module was saved (the editors hide the button until then), so no id ever has to be
// guessed from a position.

export const subtypePropertyName = (subtypeId: number, property: string) =>
  `subtype${subtypeId}.${property}`

export const checklistItemTextProperty = (subtypeId: number, itemId: number) =>
  `subtype${subtypeId}.checklistItem${itemId}.text`
